module.exports = "<label>{{caption}}</label>\r\n\r\n   <input type=\"time\"  (keypress)=\"keyPress($event)\"   (click)=\"openTimePicker()\" theme='material-blue'  [disabled]=\"disabled\" style=\"position: relative;height: 28px;\" class=\"form-control ixsControl\" [(ngModel)]=\"value\" (blur)=\"onBlur()\">\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/time/time.component.html
// module id = 1063
// module chunks = 22